import React from 'react';

const SectionEyebrow = ({ children, light = false }) => (
  <p className={`text-[11px] tracking-[0.28em] uppercase font-medium ${light ? 'text-[#f1ead9]/80' : 'text-[#942222]/70'}`}>
    {children}
  </p>
);

export default SectionEyebrow;
